import { useTaskContext } from '../../context.js';
import { FacitContainer } from './organism.facit-container.js';
import { InputContainer } from './organism.input-container.js';
import { jsx } from 'react/jsx-runtime';

function SelectAnswersHyphenateWords(props) {
  const context = useTaskContext();
  return context === "input" ? /*#__PURE__*/jsx(InputContainer, {
    ...props
  }) : /*#__PURE__*/jsx(FacitContainer, {
    ...props
  });
}

export { SelectAnswersHyphenateWords };
//# sourceMappingURL=_task.hyphenate-words.js.map
